import { SdkBaseAddonModel } from '.';

export class SdkAddonIcon extends SdkBaseAddonModel {}
